module.exports = __webpack_public_path__ + "static/img/1.6683df4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/1.png
// module id = 3Y9e
// module chunks = 0